import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cube",
  "use": "icon-cube-usage",
  "viewBox": "0 0 44 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 48\" id=\"icon-cube\">\r\n  <path id=\"icon-cube_cube\" d=\"M22.99,4.562,41,14.494v19.37l-18,9.6-18-9.6V14.376L22.99,4.562ZM23,0,1,12V36.262L23,48,45,36.262V12.13L23,0Zm0,9.594L9,17V31.152l14,7.18,14-7.18V17.078L23,9.594Zm7.27,8.42-7.25,3.728-7.176-3.836,7.146-3.782ZM13,20.92,21,25.2v7.614l-8-4.1ZM25,32.812V25.22l8-4.112v7.6l-8,4.1Z\" transform=\"translate(-1)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol